import {Flex, Progress, Text} from "@chakra-ui/react";
import {METER_COLORS, tabularNums} from "./creditsWidgetStyles.ts";

interface PlanUsageMeterProps {
  usedPercent: number;
  isWarning: boolean;
}

const PlanUsageMeter = ({usedPercent, isWarning}: PlanUsageMeterProps) => (
  <>
    {/* The bar's own name and value announce this row, so screen readers skip the visible copy. */}
    <Flex mt={2} justify="space-between" gap={2} fontSize="xs" color="n.300" aria-hidden="true">
      <Text as="span">This month's plan</Text>
      <Text as="span" sx={tabularNums}>{usedPercent}% used</Text>
    </Flex>
    <Progress
      mt={1}
      value={usedPercent}
      aria-label="This month's plan used"
      aria-valuetext={`${usedPercent}% used`}
      size="sm"
      rounded="full"
      bg="n.600"
      transition="background-color 200ms linear"
      // One tone up on hover, so the track stays visible on the n.600 wash.
      _groupHover={{bg: "n.500"}}
      sx={{"& > div": {bg: METER_COLORS[isWarning ? "warning" : "plan"]}}}
    />
  </>
);

export default PlanUsageMeter;
